import apiClient from './apiClient';

export async function fetchSimulations() {
  const { data } = await apiClient.get('/simlab/sessions');
  return data.map((x) => ({ ...x, status: x.status?.toLowerCase() }));
}

export async function scheduleSimulation(payload) {
  const { data } = await apiClient.post('/simlab/sessions', payload);
  return { ...data, status: data.status?.toLowerCase() };
}

export async function patchSimulation(id, changes) {
  const { data } = await apiClient.patch(`/simlab/sessions/${id}`, { ...changes, status: changes.status?.toUpperCase() });
  return { ...data, status: data.status?.toLowerCase() };
}
